import api from "@/api";
import { getMobilePlatform } from "@/utils/mobilePlatform";
const CurrentModule = {
    state: () => ({
        song: {},
        playedSongs: [], // Track played songs history
        appDownloadPlatform: null,
        appDownloadTitle: null,
    }),
    mutations: {
        UPDATE_SONG(state, payload) {
            state.song = payload;
        },
        SHOW_APP_DOWNLOAD(state, { platform, title }) {
            state.appDownloadPlatform = platform;
            state.appDownloadTitle = title;
        },
        HIDE_APP_DOWNLOAD(state) {
            state.appDownloadPlatform = null;
            state.appDownloadTitle = null;
        },
        ADD_TO_PLAYED_SONGS(state, payload) {
            // Add song to played history, avoid duplicates at the front
            const existingIndex = state.playedSongs.findIndex(
                (song) => song.id === payload.id,
            );
            if (existingIndex !== -1) {
                // Remove existing entry
                state.playedSongs.splice(existingIndex, 1);
            }
            // Add to the beginning
            state.playedSongs.unshift({
                ...payload,
                playedAt: new Date().toISOString(),
            });
            // Keep only last 50 played songs
            if (state.playedSongs.length > 50) {
                state.playedSongs = state.playedSongs.slice(0, 50);
            }

            // Save to localStorage
            try {
                if (typeof window !== "undefined") {
                    window.localStorage.setItem(
                        "nomad_played_songs",
                        JSON.stringify(state.playedSongs),
                    );
                }
            } catch (error) {
                console.error("Error saving to localStorage:", error);
            }
        },
        LOAD_PLAYED_SONGS(state) {
            // Load from localStorage on app init
            try {
                if (typeof window === "undefined") {
                    return;
                }

                const stored =
                    window.localStorage.getItem("nomad_played_songs");
                if (stored) {
                    state.playedSongs = JSON.parse(stored);
                }
            } catch (error) {
                console.error("Error loading from localStorage:", error);
                state.playedSongs = [];
            }
        },
        CLEAR_PLAYED_SONGS(state) {
            state.playedSongs = [];
            try {
                if (typeof window !== "undefined") {
                    window.localStorage.removeItem("nomad_played_songs");
                }
            } catch (error) {
                console.error("Error clearing localStorage:", error);
            }
        },
    },
    actions: {
        async prepareCurrent({ commit, dispatch }, payload) {
            const mobilePlatform = getMobilePlatform();

            if (mobilePlatform) {
                commit("SHOW_APP_DOWNLOAD", {
                    platform: mobilePlatform,
                    title:
                        payload.name ||
                        payload.title ||
                        (payload.type === "EPISODE"
                            ? "this episode"
                            : "this song"),
                });
                return;
            }

            commit("HIDE_APP_DOWNLOAD");
            const current = await api.CurrentApi.fetchSong(payload);
            let { mp3, sources } = current.data.data;

            if (payload.stream) {
                current.data.data.stream = payload.stream;
            }

            if (mp3) {
                commit("UPDATE_SONG", current.data.data);
                // Add to played songs history
                commit("ADD_TO_PLAYED_SONGS", current.data.data);
            } else {
                dispatch(
                    "notification/showNotification",
                    { message: "content not available", type: "info" },
                    { root: true },
                );
            }
        },
        loadPlayedSongs({ commit }) {
            commit("LOAD_PLAYED_SONGS");
        },
        clearPlayedSongs({ commit }) {
            commit("CLEAR_PLAYED_SONGS");
        },
    },
    getters: {
        currentSong(state) {
            return state.song;
        },
        playedSongs(state) {
            return state.playedSongs;
        },
        recentlyPlayed(state) {
            return state.playedSongs.slice(0, 10); // Get last 10 played songs
        },
    },
    namespaced: true,
};

export default CurrentModule;
